export const NANIT_KUSTOMER_RMA_CREATE_COMMAND_STARTED_METADATA_KEY =
  "_redo_nanit_kustomer_rma_create_command_started";
export const NANIT_KUSTOMER_RMA_CREATED_METADATA_KEY =
  "_redo_nanit_kustomer_rma_created";
export const NANIT_KUSTOMER_RMA_KOBJECT_CREATE_STARTED_METADATA_KEY =
  "_redo_nanit_kustomer_rma_kobject_create_started";
export const NANIT_KUSTOMER_RMA_KOBJECT_CREATED_METADATA_KEY =
  "_redo_nanit_kustomer_rma_kobject_created";
export const NANIT_NETSUITE_RMA_TRAN_ID_METADATA_KEY =
  "_redo_nanit_netsuite_rma_tran_id";
export const NANIT_RMA_LABEL_PENDING_METADATA_KEY =
  "_redo_nanit_rma_label_pending";

interface ReturnMetadataEntry {
  key?: string | null;
  value?: string | null;
}

export function hasNanitNetSuiteRmaTranIdMetadata(
  metadata: readonly ReturnMetadataEntry[] | null | undefined,
): boolean {
  return (
    metadata?.some(
      (entry) => entry.key === NANIT_NETSUITE_RMA_TRAN_ID_METADATA_KEY,
    ) ?? false
  );
}

export function hasPendingNanitRmaLabelMetadata(
  metadata: readonly ReturnMetadataEntry[] | null | undefined,
): boolean {
  const isPending =
    metadata?.some(
      (entry) =>
        entry.key === NANIT_RMA_LABEL_PENDING_METADATA_KEY &&
        entry.value === "true",
    ) ?? false;

  return isPending && !hasNanitNetSuiteRmaTranIdMetadata(metadata);
}
